import React from 'react'

import { InsertedPortal } from '../../controls/inserted_portal'
import {
  WIDGET_LAYOUT,
  iframeElements,
  isFirstInCollection,
  isLastInCollection,
} from './constants'

export const InfiniteScrollPlaceholders = ({
  dialogIsVerticalScrollContainer,
  welcomeMessage,
  widgetLayout,
}: any) => {
  return (
    <>
      {/* This is a placeholder image, to give the illusion of infinite, recursive scroll */}
      {isFirstInCollection && dialogIsVerticalScrollContainer && (
        <InsertedPortal
          id={'widget-scroll-bottom-placeholder'}
          siblingElement={
            iframeElements[iframeElements.length - 1].parentElement
          }
          after
          style={scrollPlaceholderContainerStyles}
        >
          <img
            src={welcomeMessage.welcome_video_poster}
            style={{
              ...scrollPlaceholderStyles,
              ...(widgetLayout === WIDGET_LAYOUT.FULLSCREEN
                ? scrollPlaceholderFullscreenStyles
                : scrollPlaceholderNotFullscreenStyles),
            }}
          />
        </InsertedPortal>
      )}
      {/* This is a placeholder image, to give the illusion of infinite, recursive scroll */}
      {isLastInCollection && dialogIsVerticalScrollContainer && (
        <InsertedPortal
          id={'widget-scroll-top-placeholder'}
          siblingElement={iframeElements[0].parentElement}
          style={scrollPlaceholderContainerStyles}
        >
          <img
            src={welcomeMessage.welcome_video_poster}
            style={{
              ...scrollPlaceholderStyles,
              ...(widgetLayout === WIDGET_LAYOUT.FULLSCREEN
                ? scrollPlaceholderFullscreenStyles
                : scrollPlaceholderNotFullscreenStyles),
            }}
          />
        </InsertedPortal>
      )}
    </>
  )
}

const scrollPlaceholderContainerStyles = {
  scrollSnapAlign: 'start',
  scrollSnapStop: 'always',
}
const scrollPlaceholderStyles = {
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  display: 'block',
  margin: 'auto',
}

const scrollPlaceholderNotFullscreenStyles = {
  borderRadius: '20px',
  border: '3px solid transparent',
}

const scrollPlaceholderFullscreenStyles = {
  objectFit: 'cover',
}
